import React from 'react';
import ReactHtmlParser from 'react-html-parser';

const Incluye = (props) => (
  <div className='seccion'>

    INCLUYE
    {' '}
    <br />
    {ReactHtmlParser(props.descripcion)}

  </div>
);
export default Incluye;
